import Button from "@/common/components/Button";
import ResumeItem from "@/common/components/ResumeItem";
import { ShowHeader } from "@/common/components/ShowHeader";
import Tabs from "@/common/components/Tabs";
import { formatCurrency } from "@/common/utils/formatters";
import EssentialInformationForm from "@/features/consumption/components/EssentialInformationForm";
import ProductsForm from "@/features/consumption/components/ProductsForm";
import { ConsumptionValidationSchema } from "@/features/consumption/schemas/create.schema";
import { useFormContext } from "react-hook-form";

interface ConsumptionMobileInformationScreenProps {
  clearForm: (exceptCardIdentifier?: boolean) => void;
  handleTabChange: (tab: number) => void;
}

const ConsumptionMobileInformationScreen = ({ clearForm, handleTabChange }: ConsumptionMobileInformationScreenProps) => {
  const { watch } = useFormContext<ConsumptionValidationSchema>();

  const watchTotalAmount = watch('total_amount');

  const cardId = watch("card_id");
  const buyerCpf = watch("buyer_cpf");
  const cardAvailableToConsume = watch("card_available_to_consume");
  const watchProducts = watch('line_items_attributes');

  return (
    <div className="flex flex-col items-stretch w-screen h-dvh absolute top-0 left-0">
      <ShowHeader
        backTo="/home"
        title="Consumo"
        className="p-4 mb-0"
        titleClassName="text-base font-normal"
        goBackIconSize={24}
      />

      <div className="h-full overflow-hidden">
        <Tabs
          useTabsAsRoutes={false}
          tabsClassName="w-screen h-full flex flex-col"
          tabsListClassName="w-full h-10 bg-transparent rounded-none"
          tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
          tabsContentClassName="h-full overflow-auto mt-0"
          tabsList={[
            {
              value: '',
              label: 'Detalhes',
              body: (
                <div className="p-4">
                  <EssentialInformationForm
                    clearForm={clearForm}
                  />
                </div>
              ),
            },
            {
              value: 'products',
              label: 'Produtos',
              disabled: !cardId || !cardAvailableToConsume,
              body: (
                <div className="p-4">
                  <ProductsForm />
                </div>
              ),
            },
          ]}
        />
      </div>

      <div className="mt-auto bg-white-200 p-4">
        <div className="flex items-center justify-between">
          <div>
            <ResumeItem
              label="Valor total"
              value={formatCurrency(watchTotalAmount || 0)}
              valueClassName="-mt-1 font-bold"
            />
          </div>

          <Button
            onClick={() => handleTabChange(1)}
            disabled={!cardId || !buyerCpf || Number(watchProducts?.length) === 0}
          >
            Ver resumo
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ConsumptionMobileInformationScreen;
